import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function GuaranteeSection() {
  return <section className="py-12 md:py-20 px-4 bg-brand-guarantee border-y-4 border-brand-green" data-id="element-146">
      <div className="max-w-4xl mx-auto text-center" data-id="element-147">
        <ShieldCheckIcon className="w-16 h-16 md:w-24 md:h-24 text-brand-green mx-auto mb-4 md:mb-6" data-id="element-148" />

        <h2 className="text-3xl md:text-5xl font-black text-brand-dark mb-5 md:mb-8 uppercase" data-id="element-149">
          🛡️ GARANTÍA MEGAPACK MINERO — 7 DÍAS
        </h2>

        <div className="text-xl md:text-2xl text-gray-800 space-y-3 md:space-y-4 font-medium mb-8 md:mb-12 max-w-3xl mx-auto" data-id="element-150">
          <p data-id="element-151">
            Descargás el material. Lo revisás. Si sentís que no vale lo que
            pagaste, te devolvemos el 100% de tu dinero.
          </p>
          <p className="text-3xl font-black text-brand-green py-4" data-id="element-152">
            Sin preguntas. Sin vueltas.
          </p>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-153">
          <CTAButton text="→ EMPEZAR HOY CON GARANTÍA" href="#compra" data-id="element-154" />
        </div>
      </div>
    </section>;
}